export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'd5307181-198c-41eb-9616-18a9682e593a';
export const MODAL_CLOSE_SEC = 2.5;